// types
import type { GuardProps } from 'types/auth'
// project import
import useAuth from 'hooks/useAuth'
import { useEffect } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

// ==============================|| PASSWORD CHANGE GUARD ||============================== //

const ALLOWED_PATHS_WHEN_PASSWORD_CHANGE_REQUIRED = ['/require-password-change', '/password-reset-success', '/logout']

function PasswordChangeGuard({ children }: GuardProps) {
  const { profile, isLoading } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Don't check if still loading
    if (isLoading) {
      return
    }

    // Check if user needs to change password
    const needsPasswordChange = profile?.user?.passwordChangeRequired === true

    // If password change is required and user is not on an allowed path
    if (needsPasswordChange && !ALLOWED_PATHS_WHEN_PASSWORD_CHANGE_REQUIRED.includes(location.pathname)) {
      console.log('Password change required - redirecting to /require-password-change')
      navigate('/require-password-change', {
        replace: true,
        state: { from: location.pathname },
      })
    }

    // If user is on password change page but doesn't need to change password
    if (!needsPasswordChange && location.pathname === '/require-password-change') {
      console.log('Password change not required - redirecting to dashboard')
      navigate('/dashboard', { replace: true })
    }
  }, [profile, isLoading, location.pathname, navigate])

  return children
}

export default PasswordChangeGuard
